<template>
  <rounded-card
    height="auto"
    show-right-btn
    :head-text="$t('result.oops')"
    @set-close-status="$emit('close')"
  >
    <div class="sqe-root w-full px-6 pb-2 flex flex-1 flex-col items-center text-center">
      <!-- Error owns the title, the subtitle and the tiles -->
      <mobile-scan-error :reasons="reasons" />
      <c-button class="sqe-action mt-auto" @click="$emit('retry')">
        <span>{{ $t('result.scan_again') }}</span>
      </c-button>
    </div>
  </rounded-card>
</template>

<script>
import RoundedCard from '@/components/common/RoundedCard.vue';
import CButton from '@/components/common/CButton.vue';
import MobileScanError from '@/components/MobileScan2/Error.vue';

export default {
  name: 'ScanError',
  components: {
    RoundedCard,
    CButton,
    MobileScanError,
  },
  props: {
    // the reasons returned by getScanErrorReason in modules/scan-quality-error
    reasons: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.sqe-root {
  color: #2c2c2c;
}
.sqe-action {
  margin-bottom: calc(1rem + env(safe-area-inset-bottom));
}
</style>
